export const routeName = 'cookies';
/** The word is the same in all five, as it already was on the site this one replaced. */
export const slugs: Record<string, string> = {
	es: 'cookies',
	en: 'cookies',
	ca: 'cookies',
	fr: 'cookies',
	it: 'cookies',
};
export const sitemap = { changefreq: 'yearly', priority: '0.3', lastmod: '2026-09-02' };
